import React from 'react'
import { useStrategicCountdownData } from '../hooks/useStrategicCountdownData'

export default function StrategicCountdownTable() {
  const { currentYear, error, loading, marketRows, bmrRows, totalRow } = useStrategicCountdownData()

  return (
    <div className="strategic-countdown">
      {error && (
        <div className="banner warn strategic-countdown-error">
          <p>Error loading strategic countdown: {error}</p>
        </div>
      )}

      <div className="strategic-countdown-heading">
        <span className="strategic-countdown-heading-year">{currentYear}</span>
        <span className="strategic-countdown-heading-title">Strategic Countdown</span>
      </div>

      <div className="strategic-countdown-table-wrap">
        <table className="strategic-countdown-table">
          <colgroup>
            <col className="strategic-countdown-col-label" />
            <col className="strategic-countdown-col-metric" />
            <col className="strategic-countdown-col-metric" />
            <col className="strategic-countdown-col-metric" />
            <col className="strategic-countdown-col-metric" />
            <col className="strategic-countdown-col-metric" />
          </colgroup>
          <thead>
            <tr>
              <th>Project<br />Product</th>
              <th>Inv.</th>
              <th>Backlog</th>
              <th>Models</th>
              <th>Rem. {currentYear}</th>
              <th>Rem. {currentYear} for MAX</th>
            </tr>
          </thead>
          <tbody>
            {[...marketRows, ...bmrRows].map(row => (
              <tr key={row.key}>
                <td className="strategic-countdown-label-cell">
                  <span className="strategic-countdown-label-inner">
                    <span
                      className="strategic-countdown-label-swatch"
                      style={{ backgroundColor: row.fill }}
                    />
                    <span className="strategic-countdown-label-text">
                      <span className="strategic-countdown-label-project">
                        {row.label.replace(' -Mkt.', '').replace(' -BMR', '')}
                      </span>
                      <span className="strategic-countdown-label-segment">
                        {row.label.endsWith(' -BMR') ? 'BMR' : 'Mkt.'}
                      </span>
                    </span>
                  </span>
                </td>
                <td>{loading ? '...' : row.inventory}</td>
                <td>{loading ? '...' : row.backlog}</td>
                <td>{loading ? '...' : row.models}</td>
                <td className="strategic-countdown-totalish">{loading ? '...' : row.total}</td>
                <td className="strategic-countdown-plan">{row.plan}</td>
              </tr>
            ))}
            <tr className="strategic-countdown-grand-total">
              <td>TOTALS</td>
              <td>{loading ? '...' : totalRow.inventory}</td>
              <td>{loading ? '...' : totalRow.backlog}</td>
              <td>{loading ? '...' : totalRow.models}</td>
              <td>{loading ? '...' : totalRow.total}</td>
              <td>{totalRow.plan}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
